import React, { useEffect, useState } from "react";
import "./Information.scss";
import { FaCompressArrowsAlt } from "react-icons/fa";
import { MdDeliveryDining } from "react-icons/md";
import { ImHangouts } from "react-icons/im";
import CardStatsWithAreaChart from "../../../../Vuexy/card-stats-with-area-chart";
import CustomAvatar from "../../../../Vuexy/avatar";
import Icone from "../../../../Vuexy/icon";

const Information = () => {
  const [salesData, setSalesData] = useState({});
  const [orderData, setOrderData] = useState({});
  const [outstandingData, setOutstandingData] = useState({});

  useEffect(() => {
    const saleData = JSON.parse(sessionStorage.getItem("Home_Sale"));
    const orderData = JSON.parse(sessionStorage.getItem("Home_Order"));
    const outstandingData = JSON.parse(
      sessionStorage.getItem("Home_Outstanding")
    );

    if (saleData) setSalesData(saleData);
    if (orderData) setOrderData(orderData);
    if (outstandingData) setOutstandingData(outstandingData);
  }, []);

  const roundFigure = (value) => {
    return value ? Math.round(value) : 0;
  };
  
  const formatAmount = (amount) => {
    if (amount >= 1000000) {
      return (amount / 1000000).toFixed(1) + "M";
    } else if (amount >= 1000) {
      return (amount / 1000).toFixed(1) + "K";
    } else {
      return amount?.toString();
    }
  };
  
  return (
    <div className="sale_information_main_div">
      <div className="inforBox1_main">
        <div className="infobox1_div">
          <CustomAvatar
            skin="light"
            color="success"
            variant="rounded"
            sx={{ width: 42, height: 42 }}
          >
            <Icone icon="tabler:credit-card" fontSize="1.625rem" />
          </CustomAvatar>
          <p className="box1_title">Sales</p>
        </div>
        <div className="infor_sub_info_main_div">
          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="box1_sub_title">Amt :</p>
            <span className="box1_sub_value">
              {formatAmount(salesData.SaleAmount || "0.00")}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="box1_sub_title">N.wt :</p>
            <span className="box1_sub_value">
              {(roundFigure(salesData.SaleNetWt))?.toFixed(3)}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="box1_sub_title">G.wt :</p>
            <span className="box1_sub_value">
              {(roundFigure(salesData.SaleGrossWt))?.toFixed(3)}
            </span>
          </div>
        </div>
      </div>

      <div className="inforBox1_main">
        <div className="infobox1_div">
          <CustomAvatar
            skin="light"
            color="error"
            variant="rounded"
            sx={{ width: 42, height: 42 }}
          >
            <Icone icon="tabler:shopping-cart" fontSize="1.625rem" />
          </CustomAvatar>
          <p className="box1_title">Orders</p>
        </div>

        <div className="infor_sub_info_main_div">
          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="box1_sub_title">Amt :</p>
            <span className="box1_sub_value">{formatAmount(orderData.T_Amt || "0.00")}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="box1_sub_title">N.wt :</p>
            <span className="box1_sub_value">{(roundFigure(orderData.T_Nwt))?.toFixed(3)}</span>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="box1_sub_title">G.wt :</p>
            <span className="box1_sub_value">{(roundFigure(orderData.T_Gwt))?.toFixed(3)}</span>
          </div>
        </div>
      </div>

      <div className="inforBox1_main">
        <div className="infobox1_div">
          <CustomAvatar
            skin="light"
            color="success"
            variant="rounded"
            sx={{ width: 42, height: 42 }}
          >
            <Icone icon="tabler:currency-dollar" fontSize="1.625rem" />
          </CustomAvatar>
          <p className="box1_title">Outstanding</p>
        </div>

        <div className="infor_sub_info_main_div">
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <p className="box1_sub_title">Amt :</p>
            <span className="box1_sub_value">
              {outstandingData.DT && outstandingData.DT.length > 0
                ? roundFigure(outstandingData.DT[0].TotalDueAmount).toLocaleString()
                : "00.00"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Information;

// import React, { useEffect, useState } from "react";
// import "./Information.scss";
// import { FaCompressArrowsAlt } from "react-icons/fa";
// import { MdDeliveryDining } from "react-icons/md";
// import { ImHangouts } from "react-icons/im";

// const Information = () => {
//   const [salesData, setSalesData] = useState({});
//   const [orderData, setOrderData] = useState({});
//   const [outstandingData, setOutstandingData] = useState({});

//   useEffect(() => {
//     const saleData = JSON.parse(sessionStorage.getItem("Home_Sale"));
//     const orderData = JSON.parse(sessionStorage.getItem("Home_Order"));
//     const outstandingData = JSON.parse(
//       sessionStorage.getItem("Home_Outstanding")
//     );

//     if (saleData) setSalesData(saleData);
//     if (orderData) setOrderData(orderData);
//     if (outstandingData) setOutstandingData(outstandingData);
//   }, []);

//   return (
//     <div>
//       <div className="inforBox1_main">
//         <div className="infobox1_div">
//           <p className="box1_title">Sales</p>
//           <FaCompressArrowsAlt className="box1_icone" />

//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <p className="box1_sub_title">Amt :</p>
//               <span className="box1_sub_value">
//                 {salesData.SaleAmount || "0.000"}
//               </span>
//             </div>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <p className="box1_sub_title">Net wt :</p>
//               <span className="box1_sub_value">
//                 {salesData.SaleNetWt || "0.000"}
//               </span>
//             </div>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <p className="box1_sub_title">G. Wt :</p>
//               <span className="box1_sub_value">
//                 {salesData.SaleGrossWt || "0.000"}
//               </span>
//             </div>
//           </div>
//         </div>

//         <div className="infobox1_div">
//           <p className="box1_title">Orders</p>
//           <MdDeliveryDining className="box1_icone" />

//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <p className="box1_sub_title">Amt :</p>
//               <span className="box1_sub_value">
//                 {orderData.T_Amt || "0.000"}
//               </span>
//             </div>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <p className="box1_sub_title">Net wt :</p>
//               <span className="box1_sub_value">
//                 {orderData.T_Nwt || "0.000"}
//               </span>
//             </div>
//             <div style={{ display: "flex", alignItems: "center" }}>
//               <p className="box1_sub_title">G. Wt :</p>
//               <span className="box1_sub_value">
//                 {orderData.T_Gwt || "0.000"}
//               </span>
//             </div>
//           </div>
//         </div>

//         <div className="infobox1_div">
//           <p className="box1_title">Outstanding</p>
//           <ImHangouts className="box1_icone" />

//           <div style={{ display: "flex", flexDirection: "column" }}>
//             <div
//               style={{
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "center",
//                 alignItems: "center",
//               }}
//             >
//               <p className="box1_sub_title">Amt :</p>
//               <span className="box1_sub_value">
//                 {outstandingData.DT && outstandingData.DT.length > 0
//                   ? outstandingData.DT[0].TotalDueAmount
//                   : "00.00"}
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Information;
